var _a;
// eslint-disable-next-line no-restricted-imports
import { enUS, fr, nl } from "date-fns/locale";
import { ELocale } from "../types/i18n.types";
import { isSameDay, format as dateFormat, } from "../utils/date-fns.utils";
import { getLocale } from "../utils/i18n/i18n.utils";
import { differenceInCalendarDays, max } from "./date-fns.utils";
import { addWeekdays } from "./date.utils";
var NOW = new Date();
export var dateLocales = (_a = {},
    _a[ELocale.NL] = nl,
    _a[ELocale.FR] = fr,
    _a[ELocale.EN] = enUS,
    // TODO: Remove
    _a.en_US = enUS,
    _a.en_GB = enUS,
    _a);
export var format = function (date, formatStr) {
    if (formatStr === void 0) { formatStr = "dd/MM/yyyy"; }
    return date === undefined
        ? ""
        : dateFormat(date, formatStr, {
            locale: dateLocales[getLocale() || nl],
        });
};
export var getPeriod = function (paymentRequest, dateFormat) {
    var dueDateAt = paymentRequest.dueDateAt, startedAt = paymentRequest.startedAt, endedAt = paymentRequest.endedAt;
    var dueDateAtFormatted = format(dueDateAt, dateFormat);
    if (!startedAt) {
        return dueDateAtFormatted;
    }
    if (isSameDay(startedAt, endedAt)) {
        return dueDateAtFormatted;
    }
    var startDateFormatted = format(startedAt, dateFormat);
    var endDateFormatted = format(endedAt, dateFormat);
    return "".concat(startDateFormatted, " - ").concat(endDateFormatted);
};
export var getPeriodForPaymentRequestItem = function (paymentRequestItem, dateFormat) {
    var startedAt = paymentRequestItem.startedAt, endedAt = paymentRequestItem.endedAt;
    var startDateFormatted = format(startedAt, dateFormat);
    var endDateFormatted = format(endedAt, dateFormat);
    return "".concat(startDateFormatted, " - ").concat(endDateFormatted);
};
export var getSepaLatestApprovalDate = function (paymentRequest, offset) {
    if (offset === void 0) { offset = 3; }
    var dueDateOrNow = max([NOW, paymentRequest.dueDateAt]);
    var result = addWeekdays(dueDateOrNow, -offset);
    while (differenceInCalendarDays(result, NOW) < 0) {
        result = addWeekdays(result, 1);
    }
    return result;
};
export var getSepaDueDate = function (paymentRequest, offset) {
    if (offset === void 0) { offset = 3; }
    return addWeekdays(getSepaLatestApprovalDate(paymentRequest, offset), offset);
};
